export const UPDATE_DOB_START = 'UPDATE_DOB_START';
export const UPDATE_DOB_SUCCESS = 'UPDATE_DOB_SUCCESS';
export const UPDATE_DOB_FAILURE = 'UPDATE_DOB_FAILURE';
export const UPDATE_DOB_END = 'UPDATE_DOB_END';
export const CLEAR_UPDATE_DOB = 'CLEAR_UPDATE_DOB';
